import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import LoadingPage from "../../Components/layouts/loading";
import CustomInput from "../../CustomComponent/custom_input";
import SimpleButton from "../../Components/layouts/simple_button";
import Footer from "../../Components/Footer/footer";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import { useEffect } from "react";
import CustomTextArea from "../../CustomComponent/custom_textarea";

const Addaddress = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [city, setCity] = useState();

  useEffect(() => {
    performRequest("GET", "/pmg/cities/all-cities")
      .then((res) => {
        if (res.status === 201) {
          setCity(res?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handleCityChange = (cityName, setFieldValue) => {
    const selectedCity = city?.allCityData?.find((c) => c.city === cityName);
    if (selectedCity) {
      setFieldValue("shippingAddress.city", selectedCity.city);
      setFieldValue("shippingAddress.pincode", selectedCity.pincode);
      setFieldValue("shippingAddress.state", selectedCity.state);
    }
  };

  const handelSubmit = (values) => {
    // console.log(values);
    setLoading(true);
    performRequest("POST", "/pmg/address/create-address", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Address added successfully!");
          navigate(`/farm-shop`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">Add new address</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Formik
                  initialValues={{
                    shippingAddress: {
                      city: "",
                      state: "",
                      address: "",
                      pincode: "",
                    },
                  }}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="form-label required">Address</label>
                          <CustomTextArea
                            name="shippingAddress.address"
                            type="text"
                          />
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label required">
                            Select City
                          </label>
                          <select
                            name="shippingAddress.city"
                            className="form-select"
                            value={props.values.shippingAddress.city}
                            onChange={(e) => {
                              handleCityChange(
                                e.target.value,
                                props.setFieldValue
                              );
                            }}
                          >
                            <option value="" label="Select city" />
                            {city?.allCityData?.map((item) => (
                              <option key={item.id} value={item.city}>
                                {item.city}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3 row w-100 d-flex">
                          <div className="mb-3 w-50">
                            <label className="form-label required">
                              Pincode
                            </label>
                            <CustomInput
                              name="shippingAddress.pincode"
                              type="text"
                            />
                          </div>
                          <div className="mb-3 w-50">
                            <label className="form-label required">State</label>
                            <CustomInput
                              name="shippingAddress.state"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Add Address" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Addaddress;
